import { ChangeDetectionStrategy, Component, computed, signal, Signal, WritableSignal } from '@angular/core';
import { ActionModalTemplate } from '@core';

@Component({
  selector: 'lib-moderation-comment',
  templateUrl: './moderation-comment.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true
})
export class ModerationCommentComponent implements ActionModalTemplate<string> {
  private readonly comment: WritableSignal<string> = signal<string>('');

  readonly selected: Signal<string | null> = computed(() => {
    const value: string = this.comment().trim();

    return value.length ? value : null;
  });

  setComment(event: Event): void {
    this.comment.set((event.target as HTMLTextAreaElement).value);
  }
}
